import { } from 'reactstrap'
import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { formatDate, getHours } from '../../lib/lib'
import Skeleton from '../UI/Skeleton'

class Log extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            logColor: '',
            title: '',
            types: ['login', 'logout', 'buy', 'getCertificate'],
        }
    }

    componentDidMount() {
        const { t } = this.props
        switch (this.props.type) {
            case 'login':
                this.setState({ logColor: 'yellow', title: t('profile-logs-login') })
                break
            case 'logout':
                this.setState({ logColor: 'blue', title: t('profile-logs-logout') })
                break
            case 'buy':
                this.setState({ logColor: 'green', title: t('profile-logs-buy') })
                break
            case 'getCertificate':
                this.setState({ logColor: 'orange', title: t('profile-logs-getCertificate') })
                break
            default:
                this.setState({ logColor: 'purple', title: t('profile-logs-none') })
                break
        }
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <tr className='bg-white'>
                            <td className="log-status">
                                <div className="log-icon-point"><Skeleton style={{ verticalAlign: 'super' }} circle={true} /></div>
                                <span className="log-title md-font-size"><Skeleton width={100} /></span>
                            </td>
                            <td className="log-time md-font-size">
                                <Skeleton width={50} />
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        :
                        <tr className={this.state.types.includes(this.props.type) ? 'bg-white' : 'd-none'}>
                            <td className="log-status">
                                {
                                    this.props.view !== 'profile' ?
                                        <div className={`log-icon-point ${this.state.logColor}`}></div> :
                                        <div className="log-icon">
                                            <div className={`log-icon-point ${this.state.logColor}`}></div>
                                            <div className="log-icon-line"></div>
                                        </div>
                                }
                                <span className="log-title md-font-size">{this.state.title}</span>
                            </td>
                            {
                                this.props.view !== 'profile' &&
                                <td className="log-time md-font-size">
                                    {formatDate(this.props.time)}
                                </td>
                            }
                            <td className="log-time md-font-size">
                                {getHours(this.props.time)}
                            </td>
                            {this.props.view !== 'profile' && <td></td>}
                            {this.props.view !== 'profile' && <td></td>}
                            {this.props.view !== 'profile' && <td></td>}
                        </tr>
                }
            </React.Fragment>
        )
    }
}

Log.propTypes = {
    t: PropTypes.func,
    text: PropTypes.string,
    type: PropTypes.string,
    time: PropTypes.string,
    view: PropTypes.string,
    skeleton: PropTypes.bool,
}

export default withTranslation()(Log)



// WEBPACK FOOTER //
// ./src/components/Logs/Log.jsx